import { render, staticRenderFns } from "./Bottombar.vue?vue&type=template&id=cc2694b8&scoped=true"
var script = {}
import style0 from "./Bottombar.vue?vue&type=style&index=0&id=cc2694b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2694b8",
  null
  
)

export default component.exports